// ADR-076 (#627) — the ONE shared, React-free formatter for an election Stage and Result at
// every read boundary (the per-subsidiary won/lost admin view, and any future outcome surface).
// Sibling of `electionDesignationLabel` / `moneyMovementLabel`: a pure function reused across
// packages and cheaply unit-tested. The engineer-facing enum identifier never reaches the UI
// (per `feedback_treasurer_first_copy.md`); an unknown/future wire value passes through unchanged
// rather than crashing the route.

import { ElectionOutcomeResult, ElectionStage } from '../generated/enums.gen';

/** Display label for what happened at an election stage. */
export const ELECTION_OUTCOME_RESULT_LABELS: Record<string, string> = {
  [ElectionOutcomeResult.Advanced]: 'Advanced',
  [ElectionOutcomeResult.WentToRunoff]: 'Went to runoff',
  [ElectionOutcomeResult.Won]: 'Won',
  [ElectionOutcomeResult.Lost]: 'Lost',
  [ElectionOutcomeResult.Withdrew]: 'Withdrew',
};

/**
 * Resolves the display label for an {@link ElectionOutcomeResult}.
 *
 * @param result the raw wire result string (`'Won' | 'Lost' | …`, or any future/unknown value,
 *   which passes through unchanged — never empty, never throws).
 */
export function electionOutcomeResultLabel(result: string): string {
  return ELECTION_OUTCOME_RESULT_LABELS[result] ?? result;
}

/** Display label for the stage of the cycle an outcome was recorded against. */
export const ELECTION_STAGE_LABELS: Record<string, string> = {
  [ElectionStage.Primary]: 'Primary',
  [ElectionStage.PrimaryRunoff]: 'Primary runoff',
  [ElectionStage.General]: 'General',
  [ElectionStage.GeneralRunoff]: 'General runoff',
  [ElectionStage.SingleElection]: 'Single election',
};

/**
 * Resolves the display label for an {@link ElectionStage}.
 *
 * @param stage the raw wire stage string (`'General' | 'SingleElection' | …`, or any
 *   future/unknown value, which passes through unchanged — never empty, never throws).
 */
export function electionStageLabel(stage: string): string {
  return ELECTION_STAGE_LABELS[stage] ?? stage;
}
